



























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import LoaderMixin from '~/mixins/LoaderMixin'
@Component({
  components: {}
})
export default class DefaultTemplate extends mixins(LoaderMixin) {
  /* Props */
  @Prop({ required: false, type: Boolean, default: false })
  toggleable: boolean

  /* Watch */

  /* Data */
  showMenu: boolean = true

  /* Enums */

  /* Lifecycle */

  /* Computed */
  get hasMenu () {
    return !!this.$slots.menu
  }

  get hasHeader () {
    return !!this.$slots.header
  }

  /* Methods */
  toggleMenu () {
    this.showMenu = !this.showMenu
  }

  /* Events/Listeners */
}
